import builder from '../builder';
import ModernOffice from '../../streamline-icons/bold/modern-office.svg';

export default builder('ModernOfficeBold', ModernOffice);
